import appConfig from 'src/utils/appConfig';

export default function() {
  const gdprCountries = [
    'AUT', 'BEL', 'BGR', 'HRV', 'CYP', 'CZE',
    'DNK', 'EST', 'FRA', 'DEU', 'GRC', 'HUN',
    'IRL', 'ITA', 'LVA', 'LTU', 'LUX', 'MLT',
    'NLD', 'ANT', 'NOR', 'POL', 'PRT', 'ROU',
    'SVK', 'SVN', 'ESP', 'SWE', 'CHE', 'GBR'
  ];

  const hasGeoData = appConfig.getMyConfig().hasOwnProperty('geoData');
  const geoData = {};

  if (hasGeoData) {
    geoData.isGdprCountry = gdprCountries.includes(appConfig.getMyConfig().geoData.countryCode3);
  }

  return geoData;
};
